import React from 'react';
import {
  Accordion,
  AccordionSummary,
  NativeSelect,
  AccordionDetails,
  Typography,
  Grid,
  Paper,
  Input,
  Button,
  TextField
} from '@material-ui/core';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InputMask from 'react-input-mask';

import Header from '../../../../layout/Header';
import Subheader from '../../../../layout/Subheader';
import Loading from '../../../../components/Loading';
import PhoneMask from '../../../Collaborator/components/PhoneMask'

import useStyles from './style';
import { formatDateTimeToRender, formatDateToRender, capitalizeFirstLetter } from '../../../../utils/functions';
function Render({
  inputs,
  handleInputChange,
  handleFileChange,
  getErros,
  setErros,
  getLoading,
  onSubmit,
  findCep,
  inputsBlocked,
  getEstados,
  getMunicipios,
  getLayoutsEmailsAncoras,
  getLayoutsEmailsInteresses,
  getLayoutsEmailsAntecipacoes,
  getLayoutsEmailsAntecipacoesAprovadas,
  getLayoutsEmailsAntecipacoesReprovadas,
  getLayoutsEmailsAntecipacoesVencidas,
  getLayoutsArquivoTitulosImportação,
  getLayoutsArquivoTituloExportação,
  getLayoutsEmailsFechamentosMeses,
  destinoOpcoes,
  handleInputNumberChange
}) {
  const classes = useStyles();
  const [getLogoLoaded, setLogoLoaded] = React.useState();
  const [getAssinaturaLoaded, setAssinaturaLoaded] = React.useState();

  const handleTimeValues = (event, value) => {
    let valueFormated = value.replace(/[^0-9]/g, "");
    let horaTime = valueFormated.slice(0, 2);
    let minutosTime = valueFormated.substr(2);

    if(minutosTime.length == 1) {
      minutosTime  = Number(minutosTime) + '0'
    }

    if(minutosTime == '' && Number(horaTime) < 10) {
      horaTime  = Number(horaTime) + '0'
    } else if (Number(horaTime) > 23) {
      horaTime = '23'
    } else if (Number(horaTime) < 10) {
      horaTime  = '0' + Number(horaTime)
    } else if (horaTime == '') {
      horaTime = '00'
    }

    if (Number(minutosTime) > 59) {
      minutosTime = '59'
    } else if (Number(minutosTime) < 10) {
      minutosTime  = '0' + Number(minutosTime)
    } else if (minutosTime == '') {
      minutosTime = '00'
    }

    valueFormated = horaTime + ':' + minutosTime
    handleInputChange(event, valueFormated);
  };


  return (
    <div className={classes.root}>
      <Header />
      <Subheader
        title="Cadastrando Rede"
        back="/app/ancoras"
        loading={getLoading}
        submit={onSubmit}
        submitText="Cadastrar"
      />
      <div className={classes.content}>
        <div className={classes.rootForm} style={{ marginLeft: '5%', width: '90%' }}>
          {getLoading ? (
            <Loading />
          ) : (
            <form onSubmit={onSubmit}>
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Informações</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Cnpj</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputMask
                          mask="99.999.999/9999-99"
                          value={inputs.cnpj}
                          name="cnpj"
                          onBlur={(event) =>
                            getErros.includes('Cnpj') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Cnpj';
                              }),
                            )
                          }
                          disabled={false}
                          onChange={handleInputChange}
                          autoComplete="off"
                          tabIndex={1}
                        >
                          {() => (
                            <Input
                              className={classes.input}
                              placeholder="CNPJ"
                              name="cnpj"
                              error={getErros.includes('Cnpj')}
                            />
                          )}
                        </InputMask>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Status</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.status}
                          name="status"
                          onChange={handleInputChange}
                          error={getErros.includes('Status')}
                          onBlur={(event) =>
                            getErros.includes('Status') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Status';
                              }),
                            )
                          }
                        >
                          <option value="Ativo">Ativo</option>
                          <option value="Inativo">Inativo</option>
                          <option selected value="Pendente">
                            Pendente
                          </option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>
                        Razão Social <span style={{ color: '#d32f2f' }}>*</span>
                        <span style={{ fontSize: '12px', color: '#666', marginLeft: '5px' }}>
                          (ou Nome Fantasia)
                        </span>
                      </label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          style={{ textTransform: 'uppercase !important' }}
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Razão Social"
                          value={inputs.razaoSocial}
                          name="razaoSocial"
                          onBlur={(event) =>
                            getErros.includes('RazaoSocial') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'RazaoSocial';
                              }),
                            )
                          }
                          error={getErros.includes('RazaoSocial')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>
                        Nome Fantasia <span style={{ color: '#d32f2f' }}>*</span>
                        <span style={{ fontSize: '12px', color: '#666', marginLeft: '5px' }}>
                          (ou Razão Social)
                        </span>
                      </label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          style={{ textTransform: 'uppercase !important' }}
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Nome Fantasia"
                          value={inputs.nomeFantasia}
                          name="nomeFantasia"
                          onBlur={(event) =>
                            getErros.includes('NomeFantasia') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'NomeFantasia';
                              }),
                            )
                          }
                          error={getErros.includes('NomeFantasia')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            minLength: 3,
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Apelido Rede</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          style={{ textTransform: 'uppercase !important' }}
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Apelido"
                          value={inputs.apelido}
                          name="apelido"
                          onBlur={(event) =>
                            getErros.includes('apelido') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'apelido';
                              }),
                            )
                          }
                          error={getErros.includes('apelido')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>ERP</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          style={{ textTransform: 'uppercase !important' }}
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Erp"
                          value={inputs.erp}
                          name="erp"
                          onBlur={(event) =>
                            getErros.includes('Erp') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Erp';
                              }),
                            )
                          }
                          error={getErros.includes('Erp')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            minLength: 3,
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid Item xs={6}>
                      <label className={classes.label}>Departamento Antecipação</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          style={{ textTransform: 'uppercase !important' }}
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Departamento Antecipação"
                          value={inputs.departamentoAntecipacao}
                          name="departamentoAntecipacao"
                          onBlur={(event) =>
                            getErros.includes('DepartamentoAntecipacao') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'DepartamentoAntecipacao';
                              }),
                            )
                          }
                          error={getErros.includes('DepartamentoAntecipacao')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Link Domínio Externo</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="Link Domínio Externo"
                          value={inputs.linkDominioExterno}
                          name="linkDominioExterno"
                          onBlur={(event) =>
                            getErros.includes('LinkDominioExterno') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'LinkDominioExterno';
                              }),
                            )
                          }
                          error={getErros.includes('LinkDominioExterno')}
                          onChange={handleInputChange}
                          inputProps={{
                            maxLength: 100,
                          }}
                          autoComplete="off"
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Data Abertura Empresa</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputMask
                          mask="99/99/9999"
                          value={
                            inputs.dataAberturaEmpresa &&
                            formatDateToRender(inputs.dataAberturaEmpresa)
                          }
                          name="dataAberturaEmpresa"
                          autocomplete="off"
                          onBlur={(event) =>
                            getErros.includes('DataAberturaEmpresa') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'DataAberturaEmpresa';
                              }),
                            )
                          }
                          disabled={false}
                          onChange={handleInputChange}
                        >
                          {() => (
                            <Input
                              className={classes.input}
                              name="dataAberturaEmpresa"
                              placeholder="DATA ABERTURA EMPRESA"
                              error={getErros.includes('DataAberturaEmpresa')}
                            />
                          )}
                        </InputMask>
                      </Paper>
                    </Grid>

                    <Grid item xs={4}>
                      <label className={classes.label}>Telefone Comercial</label>
                      <Paper className={classes.medium} elevation={0}>
                        <PhoneMask
                          value={inputs.telefoneComercialNumero}
                          name="telefoneComercialNumero"
                          autocomplete="off"
                          error={getErros.includes('TelefoneComercialNumero')}
                          onBlur={event => getErros.includes('TelefoneComercialNumero') && setErros(
                            getErros.filter(function (item) {
                              return item !== 'TelefoneComercialNumero'
                            })
                          )}
                          className={classes.input}
                          placeholder="Telefone Comercial"
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={12}>
                      <label className={classes.label}>Tela de Operações Infromações</label>
                      <Paper elevation={0} className={classes.medium}>
                        <TextField
                          multiline
                          rows={5}
                          name="telaDeOperacoesInformacoes"
                          inputProps={{ disableUnderline: true, style: { textTransform: 'uppercase'} }}
                          value={inputs.telaDeOperacoesInformacoes}
                          onChange={handleInputChange}
                          error={getErros.includes('TelaDeOperacoesInformacoes')}
                          onBlur={event => getErros.includes('TelaDeOperacoesInformacoes') && setErros(
                            getErros.filter(function (item) {
                              return item !== 'TelaDeOperacoesInformacoes'
                            })
                          )}
                          className={classes.input}
                          style={{ height: 'auto' }}
                        />
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Financeiro</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={3}>
                      <label className={classes.label}>
                        CDI com Atualização Automática
                      </label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.custoCdiAtualizacaoAutomatica}
                          name="custoCdiAtualizacaoAutomatica"
                          onChange={handleInputChange}
                          error={getErros.includes('custoCdiAtualizacaoAutomatica')}
                          onBlur={(event) =>
                            getErros.includes('custoCdiAtualizacaoAutomatica') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'custoCdiAtualizacaoAutomatica';
                              }),
                            )
                          }
                        >
                          <option value={"Sim"}>
                            Sim
                          </option>
                          <option selected value={"Nao"}>Não</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={3}>
                      <label className={classes.label}>Custo CDI</label>
                      <Paper className={classes.medium} elevation={0}>
                        <CurrencyTextField
                          value={inputs.custoCdi !== '0,00' ? inputs.custoCdi : 0}
                          currencySymbol="%"
                          placeholder="Custo CDI"
                          decimalCharacter=","
                          minimumValue="0"
                          maximumValue="100"
                          style={{
                            padding: 0,
                            width: '100%',
                          }}
                          modifyValueOnWheel={false}
                          InputProps={{
                            className: classes.inputSalario,
                          }}
                          digitGroupSeparator="."
                          name="custoCdi"
                          //disabled={inputs.custoCdiAtualizacaoAutomatica == 1}
                          error={getErros.includes('CustoCdi')}
                          onChange={handleInputNumberChange}
                          onBlur={(event) =>
                            getErros.includes('CustoCdi') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'CustoCdi';
                              }),
                            )
                          }
                        />
                        <span className={classes.porcentage}>%</span>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Mínimo dias para pagamento</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          type="text"
                          className={classes.input}
                          placeholder="Mínimo dias para pagamento"
                          name="minimoDiasParaPagamento"
                          autoComplete="off"
                          onBlur={(event) =>
                            getErros.includes('MinimoDiasParaPagamento') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'MinimoDiasParaPagamento';
                              }),
                            )
                          }
                          error={getErros.includes('MinimoDiasParaPagamento')}
                          inputProps={{
                            maxLength: 2,
                          }}
                          value={inputs.minimoDiasParaPagamento}
                          onChange={(event) => {
                            if (event.target.value !== '') {
                              if (/^[0-9\b]+$/.test(event.target.value)) {
                                handleInputChange(event);
                              }
                            } else {
                              handleInputChange(event);
                            }
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Taxa percentual mínimo rede</label>
                      <Paper className={classes.medium} elevation={0}>
                        <CurrencyTextField
                          value={
                            inputs.taxaPercentualMinimoAncora !== '0,00'
                              ? inputs.taxaPercentualMinimoAncora
                              : 0
                          }
                          currencySymbol=""
                          placeholder="Taxa percentual mínimo rede"
                          decimalCharacter=","
                          style={{
                            padding: 0,
                            width: '100%',
                          }}
                          modifyValueOnWheel={false}
                          minimumValue="0"
                          maximumValue="100"
                          InputProps={{
                            className: classes.inputSalario,
                          }}
                          digitGroupSeparator="."
                          name="taxaPercentualMinimoAncora"
                          error={getErros.includes('TaxaPercentualMinimoAncora')}
                          onChange={handleInputNumberChange}
                          onBlur={(event) =>
                            getErros.includes('TaxaPercentualMinimoAncora') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'TaxaPercentualMinimoAncora';
                              }),
                            )
                          }
                        />
                        <span className={classes.porcentage}>%</span>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Taxa percentual mínimo capittale</label>
                      <Paper className={classes.medium} elevation={0}>
                        <CurrencyTextField
                          value={
                            inputs.taxaPercentualMinimoCapittale !== '0,00'
                              ? inputs.taxaPercentualMinimoCapittale
                              : 0
                          }
                          currencySymbol=""
                          placeholder="Taxa percentual mínimo rede"
                          decimalCharacter=","
                          style={{
                            padding: 0,
                            width: '100%',
                          }}
                          modifyValueOnWheel={false}
                          InputProps={{
                            className: classes.inputSalario,
                          }}
                          minimumValue="0"
                          maximumValue="100"
                          digitGroupSeparator="."
                          name="taxaPercentualMinimoCapittale"
                          error={getErros.includes('TaxaPercentualMinimoCapittale')}
                          onChange={handleInputNumberChange}
                          onBlur={(event) =>
                            getErros.includes('TaxaPercentualMinimoCapittale') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'TaxaPercentualMinimoCapittale';
                              }),
                            )
                          }
                        />
                        <span className={classes.porcentage}>%</span>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Taxa media mínimo mês rede</label>
                      <Paper className={classes.medium} elevation={0}>
                        <CurrencyTextField
                          value={
                            inputs.taxaMediaMinimoMesRede !== '0,00'
                              ? inputs.taxaMediaMinimoMesRede
                              : "0"
                          }
                          currencySymbol=""
                          placeholder="Taxa percentual mínimo rede"
                          decimalCharacter=","
                          style={{
                            padding: 0,
                            width: '100%',
                          }}
                          modifyValueOnWheel={false}
                          InputProps={{
                            className: classes.inputSalario,
                          }}
                          minimumValue="0"
                          maximumValue="100"
                          digitGroupSeparator="."
                          name="taxaMediaMinimoMesRede"
                          error={getErros.includes('TaxaMediaMinimoMesRede')}
                          onChange={handleInputNumberChange}
                          onBlur={(event) =>
                            getErros.includes('TaxaMediaMinimoMesRede') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'TaxaMediaMinimoMesRede';
                              }),
                            )
                          }
                        />
                        <span className={classes.porcentage}>%</span>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Conta corrente limite diário</label>
                      <Paper className={classes.medium} elevation={0}>
                        <CurrencyTextField
                          value={
                            inputs.contaCorrenteLimiteDiario !== '0,00'
                              ? inputs.contaCorrenteLimiteDiario
                              : 0
                          }
                          currencySymbol="R$"
                          placeholder="Conta corrente limite diário"
                          decimalCharacter=","
                          style={{
                            padding: 0,
                            width: '100%',
                          }}
                          modifyValueOnWheel={false}
                          InputProps={{
                            className: classes.inputSalario,
                          }}
                          digitGroupSeparator="."
                          name="contaCorrenteLimiteDiario"
                          error={getErros.includes('ContaCorrenteLimiteDiario')}
                          onChange={handleInputNumberChange}
                          onBlur={(event) =>
                            getErros.includes('ContaCorrenteLimiteDiario') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ContaCorrenteLimiteDiario';
                              }),
                            )
                          }
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Conta corrente limite mensal</label>
                      <Paper className={classes.medium} elevation={0}>
                        <CurrencyTextField
                          value={
                            inputs.contaCorrenteLimiteMensal !== '0,00'
                              ? inputs.contaCorrenteLimiteMensal
                              : 0
                          }
                          currencySymbol="R$"
                          placeholder="Conta corrente limite mensal"
                          decimalCharacter=","
                          style={{
                            padding: 0,
                            width: '100%',
                          }}
                          InputProps={{
                            className: classes.inputSalario,
                          }}
                          modifyValueOnWheel={false}
                          digitGroupSeparator="."
                          name="contaCorrenteLimiteMensal"
                          error={getErros.includes('ContaCorrenteLimiteMensal')}
                          onChange={handleInputNumberChange}
                          onBlur={(event) =>
                            getErros.includes('ContaCorrenteLimiteMensal') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ContaCorrenteLimiteMensal';
                              }),
                            )
                          }
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Fechamento Mês</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.fechamentoMes}
                          name="fechamentoMes"
                          onChange={handleInputChange}
                          error={getErros.includes('fechamentoMes')}
                          onBlur={(event) =>
                            getErros.includes('fechamentoMes') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'fechamentoMes';
                              }),
                            )
                          }
                        >
                          <option selected value="MesAnterior">
                            Mês Anterior
                          </option>
                          <option value="MesAtual">Mês Atual</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Questionar Fornecedor Boleto Emitido</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.questionarFornecedoresBoletosEmitidos}
                          name="questionarFornecedoresBoletosEmitidos"
                          onChange={handleInputChange}
                          error={getErros.includes('questionarFornecedoresBoletosEmitidos')}
                          onBlur={(event) =>
                            getErros.includes('questionarFornecedoresBoletosEmitidos') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'questionarFornecedoresBoletosEmitidos';
                              }),
                            )
                          }
                        >
                          <option selected value="Sim">
                            Sim
                          </option>
                          <option value="Nao">Não</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Destino de Pagamento</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.destinoPagamentoId}
                          name="destinoPagamentoId"
                          onChange={handleInputChange}
                          error={getErros.includes('destinoPagamentoId')}
                          onBlur={(event) =>
                            getErros.includes('destinoPagamentoId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'destinoPagamentoId';
                              }),
                            )
                          }
                        >
                          {destinoOpcoes.map((destino) => (
                            <option key={destino.destinoPagamentoId} value={destino.destinoPagamentoId.toString()}>
                              {capitalizeFirstLetter(destino.destinoPagamento)}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Valor Mínimo para Qualificado</label>
                      <Paper className={classes.medium} elevation={0}>
                        <CurrencyTextField
                          value={
                            inputs.valorMinimoParaQualificado !== '0,00'
                              ? inputs.valorMinimoParaQualificado
                              : 0
                          }
                          currencySymbol="R$"
                          placeholder="Valor Mínimo para Qualificado"
                          decimalCharacter=","
                          style={{
                            padding: 0,
                            width: '100%',
                          }}
                          InputProps={{
                            className: classes.inputSalario,
                          }}
                          modifyValueOnWheel={false}
                          digitGroupSeparator="."
                          name="valorMinimoParaQualificado"
                          error={getErros.includes('ValorMinimoParaQualificado')}
                          onChange={handleInputNumberChange}
                          onBlur={(event) =>
                            getErros.includes('ValorMinimoParaQualificado') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ValorMinimoParaQualificado';
                              }),
                            )
                          }
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Valor Tarifa Bancaria (FIDC)</label>
                      <Paper className={classes.medium} elevation={0}>
                        <CurrencyTextField
                          value={
                            inputs.bancoFidcValorTarifaBancaria !== '0,00'
                              ? inputs.bancoFidcValorTarifaBancaria
                              : 0
                          }
                          currencySymbol="R$"
                          placeholder="Valor Tarifa Bancaria (FIDC)"
                          decimalCharacter=","
                          style={{
                            padding: 0,
                            width: '100%',
                          }}
                          InputProps={{
                            className: classes.inputSalario,
                          }}
                          modifyValueOnWheel={false}
                          digitGroupSeparator="."
                          name="bancoFidcValorTarifaBancaria"
                          error={getErros.includes('BancoFidcValorTarifaBancaria')}
                          onChange={handleInputNumberChange}
                          onBlur={(event) =>
                            getErros.includes('BancoFidcValorTarifaBancaria') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'BancoFidcValorTarifaBancaria';
                              }),
                            )
                          }
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Valor Mínimo para não Qualificado</label>
                      <Paper className={classes.medium} elevation={0}>
                        <CurrencyTextField
                          value={
                            inputs.valorMinimoParaNaoQualificado !== '0,00'
                              ? inputs.valorMinimoParaNaoQualificado
                              : 0
                          }
                          currencySymbol="R$"
                          placeholder="Valor Mínimo para não Qualificado"
                          decimalCharacter=","
                          style={{
                            padding: 0,
                            width: '100%',
                          }}
                          InputProps={{
                            className: classes.inputSalario,
                          }}
                          modifyValueOnWheel={false}
                          digitGroupSeparator="."
                          name="valorMinimoParaNaoQualificado"
                          error={getErros.includes('ValorMinimoParaNaoQualificado')}
                          onChange={handleInputNumberChange}
                          onBlur={(event) =>
                            getErros.includes('ValorMinimoParaNaoQualificado') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ValorMinimoParaNaoQualificado';
                              }),
                            )
                          }
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Questionar Fornecedor Aceita Abatimentos/Descontos</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.questionarFornecedoresAceitaAbatimentosDescontos}
                          name="questionarFornecedoresAceitaAbatimentosDescontos"
                          onChange={handleInputChange}
                          error={getErros.includes('questionarFornecedoresAceitaAbatimentosDescontos')}
                          onBlur={(event) =>
                            getErros.includes('questionarFornecedoresAceitaAbatimentosDescontos') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'questionarFornecedoresAceitaAbatimentosDescontos';
                              }),
                            )
                          }
                        >
                          <option selected value="Sim">
                            Sim
                          </option>
                          <option value="Nao">Não</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Obriga Digito Agencia</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.obrigaDigitoAgencia}
                          name="obrigaDigitoAgencia"
                          onChange={handleInputChange}
                          error={getErros.includes('obrigaDigitoAgencia')}
                          onBlur={(event) =>
                            getErros.includes('obrigaDigitoAgencia') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'obrigaDigitoAgencia';
                              }),
                            )
                          }
                        >
                          <option selected value="Sim">
                            Sim
                          </option>
                          <option value="Nao">Não</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                        <label className={classes.label}>Tipos Dados Bancarios</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.tiposDadosBancarios}
                            name="tiposDadosBancarios"
                            onChange={handleInputChange}
                            error={getErros.includes('tiposDadosBancarios')}
                            onBlur={(event) =>
                              getErros.includes('tiposDadosBancarios') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'tiposDadosBancarios';
                                }),
                              )
                            }
                          >
                            <option selected value="Todos">
                              Todos
                            </option>
                            <option value="SomenteDadosBancarios">Somente Dados Bancarios</option>
                            <option value="SomentePix">Somente Pix</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Tipos Resumo Diario</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.tipoResumoDiario}
                            name="tipoResumoDiario"
                            onChange={handleInputChange}
                            error={getErros.includes('tipoResumoDiario')}
                            onBlur={(event) =>
                              getErros.includes('tipoResumoDiario') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'tipoResumoDiario';
                                }),
                              )
                            }
                          >
                            <option value="Desativado">
                              Desativado
                            </option>
                            <option value="TodasAsAntecipacoes">Todas as Antecipações</option>
                            <option selected value="ApenasPagamentoDMais1">Apenas Pagamento de Mais 1</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Controla Corporate</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.controlaCorporate}
                            name="controlaCorporate"
                            onChange={handleInputChange}
                            error={getErros.includes('ControlaCorporate')}
                            onBlur={(event) =>
                              getErros.includes('ControlaCorporate') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'ControlaCorporate';
                                }),
                              )
                            }
                          >
                            <option selected value="Nao">
                              Não
                            </option>
                            <option value="Sim">Sim</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>
                    Importação de arquivo de titulos
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Layout arquivos titulos importacao</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.layoutArquivoImportacaoId}
                          name="layoutArquivoImportacaoId"
                          onChange={handleInputChange}
                          error={getErros.includes('LayoutArquivoImportacaoId')}
                          onBlur={(event) =>
                            getErros.includes('LayoutArquivoImportacaoId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'LayoutArquivoImportacaoId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getLayoutsArquivoTitulosImportação.map(
                            (layoutsArquivoTitulosImportação) => (
                              <option
                                key={layoutsArquivoTitulosImportação.layoutArquivoImportacaoId}
                                value={layoutsArquivoTitulosImportação.layoutArquivoImportacaoId}
                              >
                                {layoutsArquivoTitulosImportação.nome}
                              </option>
                            ),
                          )}
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Processando arquivo</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.processandoArquivo}
                          name="processandoArquivo"
                          onChange={handleInputChange}
                          error={getErros.includes('ProcessandoArquivo')}
                          onBlur={(event) =>
                            getErros.includes('ProcessandoArquivo') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ProcessandoArquivo';
                              }),
                            )
                          }
                        >
                          <option selected value="Nao">
                            Não
                          </option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Nome pasta arquivos titulos</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="Nome Pasta Arquivo Titulos"
                          value={inputs.nomePastaArquivos}
                          name="nomePastaArquivos"
                          classes={{ input: classes.inputText }}
                          onBlur={(event) =>
                            getErros.includes('NomePastaArquivos') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'NomePastaArquivos';
                              }),
                            )
                          }
                          error={getErros.includes('NomePastaArquivos')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Vencimento de Titulo em Dias</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            type="text"
                            className={classes.input}
                            placeholder="Vencimento Titulo Em Dias"
                            name="vencimentoTituloEmDMais"
                            autocomplete="off"
                            onBlur={(event) =>
                              getErros.includes('VencimentoTituloEmDMais') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'VencimentoTituloEmDMais';
                                }),
                              )
                            }
                            error={getErros.includes('VencimentoTituloEmDMais')}
                            value={inputs.vencimentoTituloEmDMais}
                            onChange={(event) => {
                              if (event.target.value !== '') {
                                if (/^[0-9\b]+$/.test(event.target.value)) {
                                  handleInputChange(event);
                                }
                              } else {
                                handleInputChange(event);
                              }
                            }}
                          />
                        </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Tipo Loja Codigo</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.tipoLojaCodigo}
                          name="tipoLojaCodigo"
                          onChange={handleInputChange}
                          error={getErros.includes('tipoLojaCodigo')}
                          onBlur={(event) =>
                            getErros.includes('tipoLojaCodigo') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'tipoLojaCodigo';
                              }),
                            )
                          }
                        >
                          <option selected value="Alfabetico">
                            Alfabético
                          </option>
                          <option value="Numerico">Numérico</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Controla loja</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.controlaLoja}
                          name="controlaLoja"
                          onChange={handleInputChange}
                          error={getErros.includes('ControlaLoja')}
                          onBlur={(event) =>
                            getErros.includes('ControlaLoja') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ControlaLoja';
                              }),
                            )
                          }
                        >
                          <option selected value="Nao">
                            Não
                          </option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Enviar Emails de Interesse Após Processar Arquivo</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.enviarEmailsDeInteresseAposProcessarArquivo }
                          name="enviarEmailsDeInteresseAposProcessarArquivo"
                          onChange={handleInputChange}
                          error={getErros.includes('EnviarEmailsDeInteresseAposProcessarArquivo')}
                          onBlur={(event) =>
                            getErros.includes('EnviarEmailsDeInteresseAposProcessarArquivo') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EnviarEmailsDeInteresseAposProcessarArquivo';
                              }),
                            )
                          }
                        >
                          <option selected value="Nao">
                            Não
                          </option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Enviar WhatsApp Após Processar Arquivo</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.enviarWhatsAppAposProcessarArquivo}
                          name="enviarWhatsAppAposProcessarArquivo"
                          onChange={handleInputChange}
                          error={getErros.includes('EnviarWhatsAppAposProcessarArquivo')}
                          onBlur={(event) =>
                            getErros.includes('EnviarWhatsAppAposProcessarArquivo') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EnviarWhatsAppAposProcessarArquivo';
                              }),
                            )
                          }
                        >
                          <option selected value="Nao">
                            Não
                          </option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>
                    Exportação propostas aprovadas
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Layout arquivos titulos exportação</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.layoutArquivoExportacaoId}
                          name="layoutArquivoExportacaoId"
                          onChange={handleInputChange}
                          error={getErros.includes('LayoutArquivoExportacaoId')}
                          onBlur={(event) =>
                            getErros.includes('LayoutArquivoExportacaoId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'LayoutArquivoExportacaoId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getLayoutsArquivoTituloExportação.map(
                            (layoutsArquivoTitulosExportação) => (
                              <option
                                key={layoutsArquivoTitulosExportação.layoutArquivoExportacaoId}
                                value={layoutsArquivoTitulosExportação.layoutArquivoExportacaoId}
                              >
                                {layoutsArquivoTitulosExportação.nome}
                              </option>
                            ),
                          )}
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                        <label className={classes.label}>Enviar Arquivo Exportação na Aprovação</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.enviarArquivoExportacaoNaAprovacao}
                            name="enviarArquivoExportacaoNaAprovacao"
                            onChange={handleInputChange}
                            error={getErros.includes('EnviarArquivoExportacaoNaAprovacao')}
                            onBlur={(event) =>
                              getErros.includes('EnviarArquivoExportacaoNaAprovacao') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'EnviarArquivoExportacaoNaAprovacao';
                                }),
                              )
                            }
                          >
                            <option selected value="Nao">
                              Não
                            </option>
                            <option value="Sim">Sim</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Ftp status</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.ftpStatus}
                          name="ftpStatus"
                          onChange={handleInputChange}
                          error={getErros.includes('ftpStatus')}
                          onBlur={(event) =>
                            getErros.includes('ftpStatus') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ftpStatus';
                              }),
                            )
                          }
                        >
                          <option selected value="Inativo">
                            Inativo
                          </option>
                          <option value="Ativo">Ativo</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}></Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Ftp User Name</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="Ftp Name"
                          value={inputs.ftpUserName}
                          name="ftpUserName"
                          onBlur={(event) =>
                            getErros.includes('FtpUserName') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'FtpUserName';
                              }),
                            )
                          }
                          error={getErros.includes('FtpUserName')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Ftp Password</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="Ftp Password"
                          value={inputs.ftpPassword}
                          name="ftpPassword"
                          onBlur={(event) =>
                            getErros.includes('FtpPassword') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'FtpPassword';
                              }),
                            )
                          }
                          error={getErros.includes('FtpPassword')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Ftp protocolo</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.ftpProtocolo}
                          name="ftpProtocolo"
                          onChange={handleInputChange}
                          error={getErros.includes('ftpProtocolo')}
                          onBlur={(event) =>
                            getErros.includes('ftpProtocolo') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ftpProtocolo';
                              }),
                            )
                          }
                        >
                          <option selected value="Ftp">
                            Ftp
                          </option>
                          <option value="Sftp">Sftp</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}></Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Ftp Host</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="Ftp Host"
                          value={inputs.ftpHost}
                          name="ftpHost"
                          onBlur={(event) =>
                            getErros.includes('FtpHost') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'FtpHost';
                              }),
                            )
                          }
                          error={getErros.includes('FtpHost')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Ftp Port</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          type="text"
                          className={classes.input}
                          placeholder="Ftp Port"
                          name="ftpPort"
                          autocomplete="off"
                          onBlur={(event) =>
                            getErros.includes('FtpPort') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'FtpPort';
                              }),
                            )
                          }
                          error={getErros.includes('FtpPort')}
                          inputProps={{
                            maxLength: 6,
                          }}
                          value={inputs.ftpPort}
                          onChange={(event) => {
                            if (event.target.value !== '') {
                              if (/^[0-9\b]+$/.test(event.target.value)) {
                                handleInputChange(event);
                              }
                            } else {
                              handleInputChange(event);
                            }
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Ftp Directory</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="Ftp Directory"
                          value={inputs.ftpDirectory}
                          name="ftpDirectory"
                          onBlur={(event) =>
                            getErros.includes('FtpDirectory') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'FtpDirectory';
                              }),
                            )
                          }
                          error={getErros.includes('FtpDirectory')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Informações de e-mail</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    {/* E-mail Conexão */}
                    <Grid item xs={6}>
                      <label className={classes.label}>E-mail Conexão</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.emailConexao}
                          name="emailConexao"
                          onChange={handleInputChange}
                          error={getErros.includes('EmailConexao')}
                          onBlur={(event) =>
                            getErros.includes('EmailConexao') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailConexao';
                              }),
                            )
                          }
                        >
                          <option value="Smtp">SMTP</option>
                          <option value="SmtpComSsl">SMTP COM SSL</option>
                          <option value="Exchange">EXCHANGE</option>
                          <option value="AutenticacaoModerna">AUTENTICACAO MODERNA</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    
                    {/* E-mail Exchange */}
                    <Grid item xs={6}>
                      <label className={classes.label}>E-mail Exchange</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.emailExchange}
                          name="emailExchange"
                          onChange={handleInputChange}
                          error={getErros.includes('EmailExchange')}
                          onBlur={(event) =>
                            getErros.includes('EmailExchange') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailExchange';
                              }),
                            )
                          }
                        >
                          <option value="Nao">Não</option>
                          <option value="Exchange2007_SP1">Exchange 2007_SP1</option>
                          <option value="Exchange2010">Exchange 2010</option>
                          <option value="Exchange2010_SP1">Exchange 2010_SP1</option>
                          <option value="Exchange2010_SP2">Exchange 2010_SP2</option>
                          <option value="Exchange2013">Exchange 2013</option>
                          <option value="Exchange2013_SP1">Exchange 2013_SP1</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    
                    {/* E-mail Antecipação */}
                    <Grid item xs={6}>
                      <label className={classes.label}>E-mail Antecipação</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="E-mail Antecipação"
                          value={inputs.emailAntecipacao}
                          name="emailAntecipacao"
                          classes={{ input: classes.inputEmail }}
                          onBlur={(event) =>
                            getErros.includes('EmailAntecipacao') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailAntecipacao';
                              }),
                            )
                          }
                          error={getErros.includes('EmailAntecipacao')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>

                    {/* E-mail UserName */}
                    <Grid item xs={6}>
                      <label className={classes.label}>E-mail UserName</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="E-mail UserName"
                          value={inputs.emailUserName}
                          name="emailUserName"
                          classes={{ input: classes.inputEmail }}
                          onBlur={(event) =>
                            getErros.includes('EmailUserName') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailUserName';
                              }),
                            )
                          }
                          error={getErros.includes('EmailUserName')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>

                    {/* E-mail Host */}
                    <Grid item xs={6}>
                      <label className={classes.label}>E-mail Host</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="E-mail Host"
                          value={inputs.emailHost}
                          name="emailHost"
                          classes={{ input: classes.inputEmail }}
                          onBlur={(event) =>
                            getErros.includes('EmailHost') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailHost';
                              }),
                            )
                          }
                          error={getErros.includes('EmailHost')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>

                    {/* E-mail Port */}
                    <Grid item xs={6}>
                      <label className={classes.label}>E-mail Port</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          type="text"
                          className={classes.input}
                          placeholder="E-mail Port"
                          name="emailPort"
                          autoComplete="off"
                          onBlur={(event) =>
                            getErros.includes('EmailPort') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailPort';
                              }),
                            )
                          }
                          error={getErros.includes('EmailPort')}
                          inputProps={{
                            maxLength: 6,
                          }}
                          value={inputs.emailPort}
                          onChange={(event) => {
                            if (event.target.value !== '') {
                              if (/^[0-9\b]+$/.test(event.target.value)) {
                                handleInputChange(event);
                              }
                            } else {
                              handleInputChange(event);
                            }
                          }}
                        />
                      </Paper>
                    </Grid>

                    {/* E-mail Secure */}
                    <Grid item xs={6}>
                      <label className={classes.label}>E-mail Secure</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.emailSecure}
                          name="emailSecure"
                          onChange={handleInputChange}
                          error={getErros.includes('EmailSecure')}
                          onBlur={(event) =>
                            getErros.includes('EmailSecure') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailSecure';
                              }),
                            )
                          }
                        >
                          <option value="Desabilitado">Desabilitado</option>
                          <option value="Habilitado">Habilitado</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>

                    {/* E-mail Authentication */}
                    <Grid item xs={6}>
                      <label className={classes.label}>E-mail Authentication</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.emailAuthentication}
                          name="emailAuthentication"
                          onChange={handleInputChange}
                          error={getErros.includes('EmailAuthentication')}
                          onBlur={(event) =>
                            getErros.includes('EmailAuthentication') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailAuthentication';
                              }),
                            )
                          }
                        >
                          <option value="Desabilitado">Desabilitado</option>
                          <option value="Habilitado">Habilitado</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>

                    {/* E-mail Password */}
                    <Grid item xs={6}>
                      <label className={classes.label}>E-mail Password</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="E-mail Password"
                          value={inputs.emailPassword}
                          name="emailPassword"
                          onBlur={(event) =>
                            getErros.includes('EmailPassword') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailPassword';
                              }),
                            )
                          }
                          error={getErros.includes('EmailPassword')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>

                    {/* ClientId */}
                    <Grid item xs={6}>
                      <label className={classes.label}>ClientId</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="ClientId"
                          value={inputs.emailClientId}
                          name="emailClientId"
                          classes={{ input: classes.inputEmail }}
                          onBlur={(event) =>
                            getErros.includes('EmailClientId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailClientId';
                              }),
                            )
                          }
                          error={getErros.includes('EmailClientId')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 200,
                          }}
                        />
                      </Paper>
                    </Grid>
                    
                    {/* EmailObjectId - NEW FIELD */}
                    <Grid item xs={6}>
                      <label className={classes.label}>ObjectId</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="ObjectId"
                          value={inputs.emailObjectId}
                          name="emailObjectId"
                          classes={{ input: classes.inputEmail }}
                          onBlur={(event) =>
                            getErros.includes('EmailObjectId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailObjectId';
                              }),
                            )
                          }
                          error={getErros.includes('EmailObjectId')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 36,
                          }}
                        />
                      </Paper>
                    </Grid>
                    
                    {/* TenantId */}
                    <Grid item xs={6}>
                      <label className={classes.label}>TenantId</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="TenantId"
                          value={inputs.emailTenanId}
                          name="emailTenanId"
                          classes={{ input: classes.inputEmail }}
                          onBlur={(event) =>
                            getErros.includes('EmailTenanId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailTenanId';
                              }),
                            )
                          }
                          error={getErros.includes('EmailTenanId')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 200,
                          }}
                        />
                      </Paper>
                    </Grid>
                    
                    {/* EmailClientSecret - NEW FIELD */}
                    <Grid item xs={6}>
                      <label className={classes.label}>ClientSecret</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="ClientSecret"
                          value={inputs.emailClientSecret}
                          name="emailClientSecret"
                          classes={{ input: classes.inputEmail }}
                          onBlur={(event) =>
                            getErros.includes('EmailClientSecret') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailClientSecret';
                              }),
                            )
                          }
                          error={getErros.includes('EmailClientSecret')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 500,
                          }}
                        />
                      </Paper>
                    </Grid>
                    
                    {/* RedirectUri */}
                    <Grid item xs={6}>
                      <label className={classes.label}>RedirectUri</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="RedirectUri"
                          value={inputs.emailRedirectUri}
                          name="emailRedirectUri"
                          classes={{ input: classes.inputEmail }}
                          onBlur={(event) =>
                            getErros.includes('EmailRedirectUri') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailRedirectUri';
                              }),
                            )
                          }
                          error={getErros.includes('EmailRedirectUri')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 500,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>ScopesUrl</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="ScopesUrl"
                          value={inputs.emailScopesUrl}
                          name="emailScopesUrl"
                          classes={{ input: classes.inputEmail }}
                          onBlur={(event) =>
                            getErros.includes('EmailScopesUrl') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailScopesUrl';
                              }),
                            )
                          }
                          error={getErros.includes('EmailScopesUrl')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 500,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>OutlookDomain</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="OutlookDomain"
                          value={inputs.emailOutlookDomain}
                          name="emailOutlookDomain"
                          classes={{ input: classes.inputEmail }}
                          onBlur={(event) =>
                            getErros.includes('EmailOutlookDomain') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailOutlookDomain';
                              }),
                            )
                          }
                          error={getErros.includes('EmailOutlookDomain')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 200,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>AccessToken</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="AccessToken"
                          value={inputs.emailAccessToken}
                          name="emailAccessToken"
                          disabled={true}
                          classes={{ input: classes.inputEmail }}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 1000,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>AccessTokenValidate</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="AccessTokenValidate"
                          value={inputs.emailAccessTokenValidate ? new Date(inputs.emailAccessTokenValidate).toLocaleString('pt-BR') : ''}
                          name="emailAccessTokenValidate"
                          disabled={true}
                          classes={{ input: classes.inputEmail }}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 1000,
                          }}
                        />
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Layouts Emails</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Layout e-mail Rede</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.layoutEmailAncoraId}
                          name="layoutEmailAncoraId"
                          onChange={handleInputChange}
                          error={getErros.includes('LayoutEmailAncoraId')}
                          onBlur={(event) =>
                            getErros.includes('LayoutEmailAncoraId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'LayoutEmailAncoraId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getLayoutsEmailsAncoras.map((layoutEmailAncora) => (
                            <option
                              key={layoutEmailAncora.layoutEmailAncoraId}
                              value={layoutEmailAncora.layoutEmailAncoraId}
                            >
                              {layoutEmailAncora.nome}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Layout e-mail Fechamento Mês</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.layoutEmailFechamentoMesId}
                          name="layoutEmailFechamentoMesId"
                          onChange={handleInputChange}
                          error={getErros.includes('layoutEmailFechamentoMesId')}
                          onBlur={(event) =>
                            getErros.includes('layoutEmailFechamentoMesId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'layoutEmailFechamentoMesId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getLayoutsEmailsFechamentosMeses.map((layoutsEmailsFechamentoMeses) => (
                            <option
                              key={layoutsEmailsFechamentoMeses.layoutEmailFechamentoMesId}
                              value={layoutsEmailsFechamentoMeses.layoutEmailFechamentoMesId}
                            >
                              {layoutsEmailsFechamentoMeses.nome}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Layout e-mail fornecedor</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.layoutEmailFornecedorId}
                          name="layoutEmailFornecedorId"
                          onChange={handleInputChange}
                          error={getErros.includes('LayoutEmailFornecedorId')}
                          onBlur={(event) =>
                            getErros.includes('LayoutEmailFornecedorId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'LayoutEmailFornecedorId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getLayoutsEmailsAntecipacoes.map((layoutEmailFornecedor) => (
                            <option
                              key={layoutEmailFornecedor.layoutEmailFornecedorId}
                              value={layoutEmailFornecedor.layoutEmailFornecedorId}
                            >
                              {layoutEmailFornecedor.nome}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Layout e-mail interesse</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.layoutEmailInteresseId}
                          name="layoutEmailInteresseId"
                          onChange={handleInputChange}
                          error={getErros.includes('LayoutEmailInteresseId')}
                          onBlur={(event) =>
                            getErros.includes('LayoutEmailInteresseId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'LayoutEmailInteresseId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getLayoutsEmailsInteresses.map((layoutsEmailsInteresses) => (
                            <option
                              key={layoutsEmailsInteresses.layoutEmailInteresseId}
                              value={layoutsEmailsInteresses.layoutEmailInteresseId}
                            >
                              {layoutsEmailsInteresses.nome}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Layout e-mail antecipacao aprovada</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.layoutEmailAntecipacaoAprovadaId}
                          name="layoutEmailAntecipacaoAprovadaId"
                          onChange={handleInputChange}
                          error={getErros.includes('LayoutEmailAntecipacaoAprovadaId')}
                          onBlur={(event) =>
                            getErros.includes('LayoutEmailAntecipacaoAprovadaId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'LayoutEmailAntecipacaoAprovadaId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getLayoutsEmailsAntecipacoesAprovadas.map(
                            (layoutEmailAntecipacaoAprovada) => (
                              <option
                                key={
                                  layoutEmailAntecipacaoAprovada.layoutEmailAntecipacaoAprovadaId
                                }
                                value={
                                  layoutEmailAntecipacaoAprovada.layoutEmailAntecipacaoAprovadaId
                                }
                              >
                                {layoutEmailAntecipacaoAprovada.nome}
                              </option>
                            ),
                          )}
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Layout e-mail antecipacao reprovada</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.layoutEmailAntecipacaoReprovadaId}
                          name="layoutEmailAntecipacaoReprovadaId"
                          onChange={handleInputChange}
                          error={getErros.includes('LayoutEmailAntecipacaoReprovadaId')}
                          onBlur={(event) =>
                            getErros.includes('LayoutEmailAntecipacaoReprovadaId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'LayoutEmailAntecipacaoReprovadaId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getLayoutsEmailsAntecipacoesReprovadas.map(
                            (layoutEmailAntecipacaoReprovada) => (
                              <option
                                key={
                                  layoutEmailAntecipacaoReprovada.layoutEmailAntecipacaoReprovadaId
                                }
                                value={
                                  layoutEmailAntecipacaoReprovada.layoutEmailAntecipacaoReprovadaId
                                }
                              >
                                {layoutEmailAntecipacaoReprovada.nome}
                              </option>
                            ),
                          )}
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Layout e-mail antecipacao vencida</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.layoutEmailAntecipacaoVencidaId}
                          name="layoutEmailAntecipacaoVencidaId"
                          onChange={handleInputChange}
                          error={getErros.includes('LayoutEmailAntecipacaoVencidaId')}
                          onBlur={(event) =>
                            getErros.includes('LayoutEmailAntecipacaoVencidaId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'LayoutEmailAntecipacaoVencidaId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getLayoutsEmailsAntecipacoesVencidas.map(
                            (layoutEmailAntecipacaoVencida) => (
                              <option
                                key={layoutEmailAntecipacaoVencida.layoutEmailAntecipacaoVencidaId}
                                value={
                                  layoutEmailAntecipacaoVencida.layoutEmailAntecipacaoVencidaId
                                }
                              >
                                {layoutEmailAntecipacaoVencida.nome}
                              </option>
                            ),
                          )}
                        </NativeSelect>
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Slip Pagamento</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Ordem titulos</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.ordemTitulos}
                          name="ordemTitulos"
                          onChange={handleInputChange}
                          error={getErros.includes('enumAncorasOrdemTitulos')}
                          onBlur={(event) =>
                            getErros.includes('enumAncorasOrdemTitulos') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'enumAncorasOrdemTitulos';
                              }),
                            )
                          }
                        >
                          <option selected value="NumeroNotaFiscal">
                            Número nota fiscal
                          </option>
                          <option value="Loja">Loja</option>
                          <option value="Sequencia">Sequencia</option>
                          <option value="DataVencimento">Data Vencimento</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Condição</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.condicao}
                          name="condicao"
                          onChange={handleInputChange}
                          error={getErros.includes('Condicao')}
                          onBlur={(event) =>
                            getErros.includes('Condicao') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Condicao';
                              }),
                            )
                          }
                        >
                          <option selected value="0">
                            Nenhum{' '}
                          </option>
                          <option value="1">Taxa </option>
                          <option value="2">Desagio </option>
                          <option value="3">Ambos </option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Controle conta bancaria</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.controlaContaBancaria}
                          name="controlaContaBancaria"
                          onChange={handleInputChange}
                          error={getErros.includes('ControlaContaBancaria')}
                          onBlur={(event) =>
                            getErros.includes('ControlaContaBancaria') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ControlaContaBancaria';
                              }),
                            )
                          }
                        >
                          <option selected value="Nao">
                            Não
                          </option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>E-mail ancora agrupado</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.emailAncoraAgrupado}
                          name="emailAncoraAgrupado"
                          onChange={handleInputChange}
                          error={getErros.includes('EmailAncoraAgrupado')}
                          onBlur={(event) =>
                            getErros.includes('EmailAncoraAgrupado') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailAncoraAgrupado';
                              }),
                            )
                          }
                        >
                          <option selected value="Nao">
                            Não
                          </option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Segregado por loja</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.segregadoPorLoja}
                          name="segregadoPorLoja"
                          onChange={handleInputChange}
                          error={getErros.includes('SegregadoPorLoja')}
                          onBlur={(event) =>
                            getErros.includes('SegregadoPorLoja') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'SegregadoPorLoja';
                              }),
                            )
                          }
                        >
                          <option selected value="Nao">
                            Não
                          </option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>
                        Usar razao com o codigo interno do fornecedor
                      </label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.usarRazaoComCodigoInternoFornecedor}
                          name="usarRazaoComCodigoInternoFornecedor"
                          onChange={handleInputChange}
                          error={getErros.includes('UsarRazaoComCodigoInternoFornecedor')}
                          onBlur={(event) =>
                            getErros.includes('UsarRazaoComCodigoInternoFornecedor') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'UsarRazaoComCodigoInternoFornecedor';
                              }),
                            )
                          }
                        >
                          <option selected value="Nao">
                            Não
                          </option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Endereço</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Cep</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputMask
                          mask="99.999-999"
                          value={inputs.cep}
                          name="cep"
                          disabled={false}
                          onChange={handleInputChange}
                          onBlur={(event) => {
                            if (getErros.includes('Cep')) {
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Cep';
                                }),
                              );
                            }
                            findCep(inputs.cep);
                          }}
                        >
                          {() => (
                            <Input
                              className={classes.input}
                              placeholder="CEP"
                              name="cep"
                              inputProps={{
                                autoComplete: 'off',
                              }}
                              error={getErros.includes('Cep')}
                            />
                          )}
                        </InputMask>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Logradouro</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Logradouro"
                          name="logradouro"
                          readOnly={inputsBlocked.includes('logradouro')}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                          onBlur={(event) =>
                            getErros.includes('Logradouro') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Logradouro';
                              }),
                            )
                          }
                          error={getErros.includes('Logradouro')}
                          value={inputs.logradouro}
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Bairro</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Bairro"
                          name="bairro"
                          readOnly={inputsBlocked.includes('bairro')}
                          autoComplete="off"
                          onBlur={(event) =>
                            getErros.includes('Bairro') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Bairro';
                              }),
                            )
                          }
                          error={getErros.includes('Bairro')}
                          value={inputs.bairro}
                          inputProps={{
                            maxLength: 50,
                          }}
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Estado</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.estadoId}
                          name="estadoId"
                          disabled={inputsBlocked.includes('estado')}
                          onChange={handleInputChange}
                          error={getErros.includes('EstadoId')}
                          onBlur={(event) =>
                            getErros.includes('EstadoId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EstadoId';
                              }),
                            )
                          }
                        >
                          <option value="">Selecione o estado</option>
                          {getEstados.map((estado) => (
                            <option key={estado.estadoId} value={estado.estadoId}>
                              {estado.estado}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>

                    <Grid item xs={1}>
                      <label className={classes.label}>Número</label>
                      <Paper className={classes.small} elevation={0}>
                        <Input
                          type="text"
                          className={classes.input}
                          placeholder="Número"
                          name="numero"
                          autoComplete="off"
                          onBlur={(event) =>
                            getErros.includes('Numero') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Numero';
                              }),
                            )
                          }
                          error={getErros.includes('Numero')}
                          inputProps={{
                            maxLength: 6,
                          }}
                          value={inputs.numero}
                          onChange={(event) => {
                            if (event.target.value !== '') {
                              if (/^[0-9\b]+$/.test(event.target.value)) {
                                handleInputChange(event);
                              }
                            } else {
                              handleInputChange(event);
                            }
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={5}>
                      <label className={classes.label}>Complemento</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Complemento"
                          name="complemento"
                          autoComplete="off"
                          onBlur={(event) =>
                            getErros.includes('Complemento') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Complemento';
                              }),
                            )
                          }
                          error={getErros.includes('Complemento')}
                          inputProps={{
                            maxLength: 50,
                          }}
                          value={inputs.complemento}
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Município</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.municipioId}
                          name="municipioId"
                          onChange={handleInputChange}
                          error={getErros.includes('MunicipioId')}
                          onBlur={(event) =>
                            getErros.includes('MunicipioId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'MunicipioId';
                              }),
                            )
                          }
                          disabled={inputsBlocked.includes('municipio')}
                        >
                          <option>Selecione o município</option>
                          {getMunicipios.map((municipio) => (
                            <option key={municipio.municipioId} value={municipio.municipioId}>
                              {municipio.municipio}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Horarios para aprovação de propostas</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details} style={{ flexDirection: 'column' }}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Aprovação após horario limite</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.aprovacaoAposHoraLimite}
                          name="aprovacaoAposHoraLimite"
                          onChange={handleInputChange}
                          error={getErros.includes('AprovacaoAposHoraLimite')}
                          onBlur={(event) =>
                            getErros.includes('AprovacaoAposHoraLimite') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'AprovacaoAposHoraLimite';
                              }),
                            )
                          }
                          disabled={inputsBlocked.includes('AprovacaoAposHoraLimite')}
                        >
                          <option selected value="NaoPermitido">
                            Não permitido
                          </option>
                          <option value="Permitido">Permitido</option>
                          <option value="PermitidoComAutorizacao">Permitido com autorização</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={2}>
                      <label className={classes.label}>Horario Limite - Segunda</label>
                      <Paper className={classes.small} elevation={0}>
                        <InputMask
                          mask="99:99"
                          value={inputs.horaLimiteAceitePropostaSegunda}
                          name="horaLimiteAceitePropostaSegunda"
                          onBlur={(event) =>
                            getErros.includes('HoraLimiteAceitePropostaSegunda') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'HoraLimiteAceitePropostaSegunda';
                              }),
                            )
                          }
                          disabled={false}
                          onChange={(event) => {handleTimeValues(event, event.target.value)}}
                          autoComplete="off"
                          tabIndex={0}
                          onFocus={(e) => {e.target.setSelectionRange(0, 0);}}
                        >
                          {() => (
                            <Input
                              className={classes.input}
                              placeholder="00:00"
                              name="horaLimiteAceitePropostaSegunda"
                              error={getErros.includes('HoraLimiteAceitePropostaSegunda')}
                            />
                          )}
                        </InputMask>
                      </Paper>
                    </Grid>
                    <Grid item xs={2}>
                      <label className={classes.label}>Horario Limite - Terça</label>
                      <Paper className={classes.small} elevation={0}>
                        <InputMask
                          mask="99:99"
                          value={inputs.horaLimiteAceitePropostaTerca}
                          name="horaLimiteAceitePropostaTerca"
                          id="horaLimiteAceitePropostaTerca"
                          onBlur={(event) =>
                            getErros.includes('HoraLimiteAceitePropostaTerca') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'HoraLimiteAceitePropostaTerca';
                              }),
                            )
                          }
                          disabled={false}
                          onChange={(event) => {handleTimeValues(event, event.target.value)}}
                          autoComplete="off"
                          tabIndex={0}
                          onFocus={(e) => {e.target.setSelectionRange(0, 0);}}
                        >
                          {() => (
                            <Input
                              className={classes.input}
                              placeholder="00:00"
                              name="horaLimiteAceitePropostaTerca"
                              error={getErros.includes('HoraLimiteAceitePropostaTerca')}
                            />
                          )}
                        </InputMask>
                      </Paper>
                    </Grid>
                    <Grid item xs={2}>
                      <label className={classes.label}>Horario Limite - Quarta</label>
                      <Paper className={classes.small} elevation={0}>
                        <InputMask
                          mask="99:99"
                          value={inputs.horaLimiteAceitePropostaQuarta}
                          name="horaLimiteAceitePropostaQuarta"
                          onBlur={(event) =>
                            getErros.includes('HoraLimiteAceitePropostaQuarta') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'HoraLimiteAceitePropostaQuarta';
                              }),
                            )
                          }
                          disabled={false}
                          onChange={(event) => {handleTimeValues(event, event.target.value)}}
                          autoComplete="off"
                          tabIndex={0}
                          onFocus={(e) => {e.target.setSelectionRange(0, 0);}}
                        >
                          {() => (
                            <Input
                              className={classes.input}
                              placeholder="00:00"
                              name="horaLimiteAceitePropostaQuarta"
                              error={getErros.includes('HoraLimiteAceitePropostaQuarta')}
                            />
                          )}
                        </InputMask>
                      </Paper>
                    </Grid>
                    <Grid item xs={2}>
                      <label className={classes.label}>Horario Limite - Quinta</label>
                      <Paper className={classes.small} elevation={0}>
                        <InputMask
                          mask="99:99"
                          value={inputs.horaLimiteAceitePropostaQuinta}
                          name="horaLimiteAceitePropostaQuinta"
                          onBlur={(event) =>
                            getErros.includes('HoraLimiteAceitePropostaQuinta') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'HoraLimiteAceitePropostaQuinta';
                              }),
                            )
                          }
                          disabled={false}
                          onChange={(event) => {handleTimeValues(event, event.target.value)}}
                          autoComplete="off"
                          tabIndex={0}
                          onFocus={(e) => {e.target.setSelectionRange(0, 0);}}
                        >
                          {() => (
                            <Input
                              className={classes.input}
                              placeholder="00:00"
                              name="horaLimiteAceitePropostaQuinta"
                              error={getErros.includes('HoraLimiteAceitePropostaQuinta')}
                            />
                          )}
                        </InputMask>
                      </Paper>
                    </Grid>
                    <Grid item xs={2}>
                      <label className={classes.label}>Horario Limite - Sexta</label>
                      <Paper className={classes.small} elevation={0}>
                        <InputMask
                          mask="99:99"
                          value={inputs.horaLimiteAceitePropostaSexta}
                          name="horaLimiteAceitePropostaSexta"
                          onBlur={(event) =>
                            getErros.includes('HoraLimiteAceitePropostaSexta') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'HoraLimiteAceitePropostaSexta';
                              }),
                            )
                          }
                          disabled={false}
                          onChange={(event) => {handleTimeValues(event, event.target.value)}}
                          autoComplete="off"
                          tabIndex={0}
                          onFocus={(e) => {e.target.setSelectionRange(0, 0);}}
                        >
                          {() => (
                            <Input
                              className={classes.input}
                              placeholder="00:00"
                              name="horaLimiteAceitePropostaSexta"
                              error={getErros.includes('HoraLimiteAceitePropostaSexta')}
                            />
                          )}
                        </InputMask>
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Configurações</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Ambiente</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.ambiente}
                          name="ambiente"
                          onChange={handleInputChange}
                          error={getErros.includes('Ambiente')}
                          onBlur={(event) =>
                            getErros.includes('Ambiente') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Ambiente';
                              }),
                            )
                          }
                          disabled={inputsBlocked.includes('Ambiente')}
                        >
                          <option selected value="Desenvolvimento">
                            Desenvolvimento
                          </option>
                          <option value="Producao">Produção</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}></Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Arquivo de Logotipo</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    {inputs.newLogotipoImagemBase64 ? (
                      <div className={classes.divLogo}>
                        <img
                          src={inputs.newLogotipoImagemBase64}
                          onError={() => setLogoLoaded(true)}
                          onLoad={() => setLogoLoaded(true)}
                        />
                      </div>
                    ) : inputs.logotipoImagemBase64 ? (
                      <div className={classes.divLogo}>
                        <img
                          src={`${inputs.logotipoImagemBase64}?date=${new Date().toLocaleString()}`}
                          onError={() => setLogoLoaded(true)}
                          onLoad={() => setLogoLoaded(true)}
                        />
                      </div>
                    ) : (
                      <></>
                    )}

                    <label className={classes.label}>Arquivo de Logotipo</label>
                    <Paper className={classes.medium} elevation={0} style={{ width: '100%' }}>
                      <Input
                        style={{ textTransform: 'uppercase !important' }}
                        className={classes.input}
                        classes={{ input: classes.inputText }}
                        placeholder="Logotipo"
                        type="file"
                        name="newLogotipoImagemBase64"
                        onBlur={(event) =>
                          getErros.includes('Logotipo') &&
                          setErros(
                            getErros.filter(function (item) {
                              return item !== 'Logotipo';
                            }),
                          )
                        }
                        error={getErros.includes('Logotipo')}
                        onChange={(event) => {
                          handleFileChange(event);
                          setLogoLoaded(false);
                        }}
                        inputProps={{
                          accept: '.jpeg, .png, .jpg',
                        }}
                        autoComplete="off"
                      />
                    </Paper>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Arquivo de Assinatura</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    {inputs.newEmailAssinaturaBase64 ? (
                      <div className={classes.divLogo}>
                        <img
                          src={inputs.newEmailAssinaturaBase64}
                          onError={() => setLogoLoaded(true)}
                          onLoad={() => setAssinaturaLoaded(true)}
                        />
                      </div>
                    ) : inputs.emailAssinaturaBase64 ? (
                      <div className={classes.divLogo}>
                        <img
                          src={`${
                            inputs.emailAssinaturaBase64
                          }?date=${new Date().toLocaleString()}`}
                          onError={() => setLogoLoaded(true)}
                          onLoad={() => setAssinaturaLoaded(true)}
                        />
                      </div>
                    ) : (
                      <></>
                    )}

                    <label className={classes.label}>Arquivo de e-mail de assinatura</label>
                    <Paper className={classes.medium} elevation={0} style={{ width: '100%' }}>
                      <Input
                        style={{ textTransform: 'uppercase !important' }}
                        className={classes.input}
                        classes={{ input: classes.inputText }}
                        placeholder="Arquivo de e-mail de assinatura"
                        name="newEmailAssinaturaBase64"
                        type="file"
                        onBlur={(event) =>
                          getErros.includes('EmailAssinatura') &&
                          setErros(
                            getErros.filter(function (item) {
                              return item !== 'EmailAssinatura';
                            }),
                          )
                        }
                        error={getErros.includes('EmailAssinatura')}
                        onChange={(event) => {
                          setAssinaturaLoaded(false);
                          handleFileChange(event);
                        }}
                        autoComplete="off"
                        inputProps={{
                          accept: '.jpeg, .png, .jpg',
                        }}
                      />
                    </Paper>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <div className={classes.divButton}>
                <Button variant="contained" type="submit" className={classes.button}>
                  Cadastrar
                </Button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default Render;
